import { DUPE_API_URL } from '@dupe/common/constants'
import { useMutation } from '@tanstack/react-query'
import useAuthUser from '~/src/hooks/useAuthUser'
import fetcher from '~/src/lib/fetcher'

interface ProcessInviteResponse {
  success: boolean
  message: string
}

interface ProcessInviteParams {
  inviteCode: string
}

export const useProcessInvite = () => {
  const { authUser } = useAuthUser()

  return useMutation({
    mutationFn: async ({ inviteCode }: ProcessInviteParams) => {
      const data = await fetcher<ProcessInviteResponse>(
        `${DUPE_API_URL}/api/user/process-invite`,
        {
          method: 'POST',
          authUser,
          dataOrParams: {
            inviteCode,
          },
        }
      )
      return data
    },
  })
}
